// This icon file is generated automatically.
var PDesktopOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.5 1.19H.5a.5.5 0 00-.5.5v7.75c0 .27.22.5.5.5h5.94v1.75H3.75a.25.25 0 00-.25.25v.75c0 .07.06.12.13.12h6.75c.06 0 .12-.05.12-.12v-.75a.25.25 0 00-.25-.25H7.56V9.94h5.94a.5.5 0 00.5-.5V1.69a.5.5 0 00-.5-.5zm-.63 7.62H1.13v-6.5h11.75v6.5z", "fill-rule": "nonzero" } }] }, "name": "p-desktop", "theme": "outlined" };
export default PDesktopOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PDesktopOutlined.js
// module id = 3333
// module chunks = 0